Ext.define('SA.data.BusinessCodes', {
    forCountry(country) {
        return this.codes[country];
    },

    getDescription(code) {
        return this.descriptions[code];
    },

    async loadAll() {
        var result = await SA.Ajax.request({resource: this.resource});

        Object.entries(result).forEach(([countryCode, businessCodes]) => {
            var all = this.codes || (this.codes = {}),
                descriptions = this.descriptions || (this.descriptions = {});

            all[countryCode] = businessCodes;

            businessCodes.forEach(arr => {


                                descriptions[arr[0]] = arr[1];
            });
        });
    }
});